export const tooltipMessage = 'This value is required for completeness'
